import _extends from "@babel/runtime/helpers/extends";
import React from 'react';

var SectionTitle = function SectionTitle(props) {
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "component-title section_title"
  }, props), props.children);
};

export default SectionTitle;